import React from 'react';
import { PhoneIcon, MailIcon, MapPinIcon, Building2Icon, FileTextIcon, FacebookIcon, InstagramIcon, LinkedinIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { NordenMascot } from './NordenMascot';

// Bedrijfsgegevens op één plek. Deze moeten exact overeenkomen met het
// Google Bedrijfsprofiel, de KvK-inschrijving en noorddigital.nl.
// Afwijkende gegevens tussen vindplaatsen schaden de lokale vindbaarheid.
export const BEDRIJFSGEGEVENS = {
  naam: 'Noord Digital',
  telefoonWeergave: '+31 6 53689686',
  telefoonLink: '+31653689686',
  email: 'info@noorddigital.nl',
  kvk: '96071044',
  btw: 'NL867457521B01',
  straat: 'Schuit 8a',
  postcode: '1724 BD',
  plaats: 'Oudkarspel',
  gemeente: 'Dijk en Waard',
  regio: 'Noord-Holland',
  linkedin: 'https://www.linkedin.com/company/noord-digital/',
  facebook: 'https://www.facebook.com/profile.php?id=61572493568612',
  instagram: 'https://www.instagram.com/noord_digital/',
  // Deze routes bestaan op noorddigital.nl. Controleer ze als daar
  // paden wijzigen, anders ontstaan hier dode links.
  privacybeleid: 'https://noorddigital.nl/privacy',
  algemeneVoorwaarden: 'https://noorddigital.nl/algemene-voorwaarden'
};
const diensten = [{
  label: 'Website laten maken',
  to: '/website-laten-maken'
}, {
  label: 'SEO voor websites',
  to: '/seo-voor-websites'
}, {
  label: 'WordPress websites',
  to: '/wordpress-websites'
}, {
  label: 'Hosting en onderhoud',
  to: '/hosting-onderhoud'
}];
const kennisbank = [{
  label: 'Alle artikelen',
  to: '/kennisbank'
}, {
  label: 'Wat kost een website',
  to: '/kosten-website-laten-maken'
}, {
  label: 'Website checklist',
  to: '/website-laten-maken-checklist'
}, {
  label: 'WordPress of Wix',
  to: '/wordpress-vs-wix'
}, {
  label: 'Website tips',
  to: '/website-tips'
}];

// De kern van het werkgebied: de gemeenten rond de vestiging in Oudkarspel.
const regio = [{
  label: 'Webdesign Alkmaar',
  to: '/webdesign-alkmaar'
}, {
  label: 'Webdesign Dijk en Waard',
  to: '/webdesign-dijk-en-waard'
}, {
  label: 'Webdesign Heerhugowaard',
  to: '/webdesign-heerhugowaard'
}, {
  label: 'Webdesign Heiloo',
  to: '/webdesign-heiloo'
}, {
  label: 'Webdesign Bergen',
  to: '/webdesign-bergen'
}, {
  label: 'Webdesign Schagen',
  to: '/webdesign-schagen'
}, {
  label: 'Webdesign Castricum',
  to: '/webdesign-castricum'
}, {
  label: 'Alle locaties',
  to: '/alle-locaties'
}];
export function Footer() {
  const jaar = new Date().getFullYear();
  return <footer className="bg-navy-950" data-id="element-427" data-mp="1hkfhz20002ap">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-id="element-428" data-mp="1hje5qu78x9re">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-6 gap-10 lg:gap-6" data-id="element-429" data-mp="1mj8qsh4cb54j">
          {/* Column 1 — Brand */}
          <div className="sm:col-span-2" data-id="element-430" data-mp="1rhk5b55ky3t3">
            <img src="https://cdn.magicpatterns.com/uploads/fGPZ5CSfvu5NW1orNYB6mv/Logo_Noord_Hooft.svg" alt="Noord Digital" className="h-10 w-auto mb-4 brightness-0 invert" loading="lazy" data-id="element-431" data-mp="1rgiosl5sop3z" />
            <p className="text-navy-400 text-sm mb-4 max-w-xs" data-id="element-432" data-mp="2afwzir5zft1r">
              Websites die gevonden worden. Voor ondernemers in Alkmaar, Dijk en
              Waard en de rest van Noord-Holland Noord.
            </p>
            {/* Norden as brand mascot */}
            <div className="flex items-center gap-3 mb-6" data-id="element-433" data-mp="1wo8rayyutoq2">
              <div className="opacity-40" data-id="element-434" data-mp="1wlm8g36ijmsj">
                <NordenMascot variant="wave" size="sm" data-id="element-435" data-mp="2tehpgfw50sdt" />
              </div>
              <span className="text-xs text-navy-500" data-id="element-436" data-mp="2pcecfmttlfqf">
                Norden, jouw digitale gids
              </span>
            </div>
            <div className="flex items-center gap-4" data-id="element-437" data-mp="2kc8ghugip72j">
              <a href={BEDRIJFSGEGEVENS.facebook} target="_blank" rel="noopener noreferrer" className="text-navy-500 hover:text-white transition-colors" aria-label="Noord Digital op Facebook" data-id="element-438" data-mp="2kf4flm43q1sk">
                <FacebookIcon className="w-5 h-5" data-id="element-439" data-mp="1414ieiwn4q90" />
              </a>
              <a href={BEDRIJFSGEGEVENS.instagram} target="_blank" rel="noopener noreferrer" className="text-navy-500 hover:text-white transition-colors" aria-label="Noord Digital op Instagram" data-id="element-440" data-mp="2ruxzubsi9uw5">
                <InstagramIcon className="w-5 h-5" data-id="element-441" data-mp="2nv78o6z2hcr3" />
              </a>
              <a href={BEDRIJFSGEGEVENS.linkedin} target="_blank" rel="noopener noreferrer" className="text-navy-500 hover:text-white transition-colors" aria-label="Noord Digital op LinkedIn" data-id="element-442" data-mp="3bk01vvob16i0">
                <LinkedinIcon className="w-5 h-5" data-id="element-443" data-mp="36kng7e9665h0" />
              </a>
            </div>
          </div>

          {/* Column 2 — Diensten */}
          <div data-id="element-444" data-mp="1q5m4fwlhhpaz">
            <h4 className="text-white font-semibold text-sm mb-4" data-id="element-445" data-mp="1q4swwtepavrs">Diensten</h4>
            <nav className="flex flex-col gap-3" data-id="element-446" data-mp="1v6iaafpeblj1">
              {diensten.map(item => <Link key={item.to} to={item.to} className="text-sm text-navy-400 hover:text-white transition-colors" data-id="element-447" data-mp="1nkwiy9b4tcgx">
                  {item.label}
                </Link>)}
            </nav>
          </div>

          {/* Column 3 — Kennisbank */}
          <div data-id="element-448" data-mp="1rocair8cgmmr">
            <h4 className="text-white font-semibold text-sm mb-4" data-id="element-449" data-mp="1rlq7n4weevav">
              Kennisbank
            </h4>
            <nav className="flex flex-col gap-3" data-id="element-450" data-mp="zwdbfvzwp3pw">
              {kennisbank.map(item => <Link key={item.to} to={item.to} className="text-sm text-navy-400 hover:text-white transition-colors" data-id="element-451" data-mp="1dnrt9zi2uyvd">
                  {item.label}
                </Link>)}
            </nav>
          </div>

          {/* Column 4 — Regio */}
          <div data-id="element-452" data-mp="g8xebpnylysp">
            <h4 className="text-white font-semibold text-sm mb-4" data-id="element-453" data-mp="g7couegi561p">Regio</h4>
            <nav className="flex flex-col gap-3" data-id="element-454" data-mp="2gb5fhtt09lmy">
              {regio.map(item => <Link key={item.to} to={item.to} className="text-sm text-navy-400 hover:text-white transition-colors" data-id="element-455" data-mp="2l9gpq5n7py5p">
                  {item.label}
                </Link>)}
            </nav>
          </div>

          {/* Column 5 — Contact */}
          <div data-id="element-456" data-mp="1xct2ty2vxtmm">
            <h4 className="text-white font-semibold text-sm mb-4" data-id="element-457" data-mp="1xdcbspak57oi">Contact</h4>
            <address className="not-italic space-y-3" data-id="element-458" data-mp="22bxc0opt7rcy">
              <a href={`tel:${BEDRIJFSGEGEVENS.telefoonLink}`} className="flex items-center gap-3 text-sm text-navy-400 hover:text-white transition-colors" data-id="element-459" data-mp="279ytx6bi1kmu">
                <PhoneIcon className="w-4 h-4 text-navy-500 flex-shrink-0" data-id="element-460" data-mp="3ip49vc0n5foe" />
                {BEDRIJFSGEGEVENS.telefoonWeergave}
              </a>
              <a href={`mailto:${BEDRIJFSGEGEVENS.email}`} className="flex items-center gap-3 text-sm text-navy-400 hover:text-white transition-colors" data-id="element-461" data-mp="3mpef2mgm0227">
                <MailIcon className="w-4 h-4 text-navy-500 flex-shrink-0" data-id="element-462" data-mp="17321w3la95ds" />
                {BEDRIJFSGEGEVENS.email}
              </a>
              <div className="flex items-center gap-3 text-sm text-navy-400" data-id="element-463" data-mp="128pi1sfw9s1i">
                <Building2Icon className="w-4 h-4 text-navy-500 flex-shrink-0" data-id="element-464" data-mp="xbpblgf4un9v" />
                KvK: {BEDRIJFSGEGEVENS.kvk}
              </div>
              <div className="flex items-center gap-3 text-sm text-navy-400" data-id="element-465" data-mp="ne1e4iq571o0">
                <FileTextIcon className="w-4 h-4 text-navy-500 flex-shrink-0" data-id="element-466" data-mp="ng4e9vl0eb6g" />
                BTW: {BEDRIJFSGEGEVENS.btw}
              </div>
              <div className="flex items-start gap-3 text-sm text-navy-400" data-id="element-467" data-mp="edv2z3hx2ds0">
                <MapPinIcon className="w-4 h-4 text-navy-500 flex-shrink-0 mt-0.5" data-id="element-468" data-mp="2dpxpkmlu7o9w" />
                <span data-id="element-469" data-mp="28r4ibbx58ti6">
                  {BEDRIJFSGEGEVENS.straat}
                  <br data-id="element-470" data-mp="28rw2zrp7d6to" />
                  {BEDRIJFSGEGEVENS.postcode} {BEDRIJFSGEGEVENS.plaats}
                  <br data-id="element-471" data-mp="1hmk262ex4u3h" />
                  <span className="text-navy-500" data-id="element-472" data-mp="1ho4lswzp2smk">
                    Gemeente {BEDRIJFSGEGEVENS.gemeente}
                  </span>
                </span>
              </div>
            </address>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-12 pt-8 border-t border-navy-800 flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-473" data-mp="1cu0egcmioiky">
          <p className="text-sm text-navy-500" data-id="element-474" data-mp="ytzb8qis4z2b">
            © {jaar} Noord Digital. Alle rechten voorbehouden.
          </p>
          <div className="flex items-center gap-6" data-id="element-475" data-mp="12ujbi2yngiso">
            <a href={BEDRIJFSGEGEVENS.privacybeleid} target="_blank" rel="noopener noreferrer" className="text-sm text-navy-500 hover:text-white transition-colors" data-id="element-476" data-mp="oyefvb87ux1j">
              Privacybeleid
            </a>
            <a href={BEDRIJFSGEGEVENS.algemeneVoorwaarden} target="_blank" rel="noopener noreferrer" className="text-sm text-navy-500 hover:text-white transition-colors" data-id="element-477" data-mp="2oagx0etdbfc1">
              Algemene voorwaarden
            </a>
          </div>
        </div>
      </div>
    </footer>;
}